<template>
  <div>
    <f7-accordion-item class="accordionForm" @accordion:open="opened=true" @accordion:close="opened=false" :expanded="opened">
      <f7-accordion-toggle class="accordionToggle">
        <div class="form-group row justify-content-start" :class="colorBottomButton">
            <div class="createInvoiceBand col-sm-auto text-uppercase">
                <span v-if="star" class="color-red"> *</span>
                {{ title }}
                <i class="f7-icons formChevron" v-if="opened">chevron_down</i>
                <i class="f7-icons formChevron" v-if="!opened">chevron_right</i>
            </div>
        </div>
      </f7-accordion-toggle>
      <f7-accordion-content :class="{hasDatePicker: hasDatePicker}">
        <slot></slot>
      </f7-accordion-content>
    </f7-accordion-item>
  </div>

</template>

<script>
export default {
  name: 'FormAccordion',
  props: {
    title: {
      type: String
    },
    open: {
      type: Boolean,
      default: true
    },
    star: {
      type: Boolean,
      default: false
    },
    hasDatePicker: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      opened: this.open
    }
  },
  computed: {
    renderOpenClass () {
      return this.opened ? 'accordion-item-expanded' : ''
    }
  }
}
</script>

<style lang="css" scoped>
.collapsed > .when-open,
:not(.collapsed) > .when-closed {
  display: none;
}

.collapsed > .when-closed,
:not(.collapsed) > .when-open {
  display: inline;
}
.accordionToggle:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// FormAccordion.vue?59da1ed8